import styled from 'styled-components';
const BasicInfoStyled = styled.div`
  .campaignName {
    width: 400px;
    height: 40px;
  }

  .beginTime-wrapper {
    /* width: 100%; */
    .MuiFormHelperText-root {
      margin-top: 8px;
    }
    > .MuiTextField-root {
      width: 100%;
      height: 40px;
    }
  }
  .frequency-single-wrapper {
    /* border: 1px solid red; */
    width: 440px;
    border-radius: 4px;
    border: 1px solid #1565c0;
    padding: 32px;
    > .row {
      display: flex;
      .MuiFormControlLabel-root {
        margin-right: 42px;
      }
      /* justify-content: space-between; */
    }
  }
  .frequency-many-wrapper {
    .mul-select {
      min-height: 40px;
      max-height: 100px;
    }
    > .row {
      display: flex;
      justify-content: space-between;
    }

    padding: 32px;
    width: 440px;
    border-radius: 4px;
    border: 1px solid #1565c0;
    .multiple-wrap-style {
      height: 40px;
    }
  }

  .table {
    padding-left: 5px;
    width: 405px;
    font-size: 16px;
    color: #000;
    font-family: SourceHanSansCN;
    .table-first {
      display: flex;
      height: 48px;
      background-color: #f6f6f6;
      align-items: center;
      justify-content: space-between;
      padding: 0 32px;
    }
    .table-second {
      display: flex;
      height: 48px;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #ddd;
      font-size: 14px;
      padding: 0 32px;
      .ask {
        /* width: 12px;
        height: 12px;
        background-color: #1565c0;
        border-radius: 50%;
        text-align: center;
        vertical-align: middle;
        font-size: 12px;
        color: #fff; */
      }
    }
  }
  .mobile-table {
    width: 600px;
  }
  .MuiFormControl-root {
    height: 80px;
  }
  .executeType {
    width: 120px;
  }
`;
export default BasicInfoStyled;
